import Cookies from 'js-cookie';

const isDev = (process.env.NODE_ENV === 'development');

const host = () => {
	if ( isDev ) {
		// return '192.168.0.129'; // 8176
		return '192.168.68.87'; // 6293
	}
	else {
		return 'v1covqp491.execute-api.us-east-2.amazonaws.com/latest';
	}
};

const webHost = () => {
	if ( isDev ) {
		return `http://${host()}:3000`;
	}
	else {
		return `https://${host()}`;
	}
};

const websocketHost = () => {
	if ( isDev ) {
		return `ws://${host()}:8080`;
	}
	else {
		return `wss://${host()}`;
	}
};

const getUserIDKey = () => {
	if ( isDev ) {
		return 'User-Id-Dev';
	}
	else {
		return 'User-Id';
	}
};

const getUserUniqueIDKey = () => {
	if ( isDev ) {
		return 'Unique-User-Id-Dev';
	}
	else {
		return 'Unique-User-Id';
	}
};

const getCurrentUserID = () => {
	const userID = Cookies.get(getUserIDKey());
	return Number(userID);
};

const isLoggedIn = () => {
	const userID = Cookies.get(getUserIDKey());
	const uniqueUserID = Cookies.get(getUserUniqueIDKey());

	if ( userID === undefined || uniqueUserID === undefined ) {
		return false;
	}

	return true;
};

const getHeaders = (contentType) => {
	if ( contentType == 'form' ) {
		contentType = 'multipart/form-data';
	}
	else {
		contentType = 'application/json';
	}

	let headers = {
		'Accept': 'application/json',
		'Content-Type': contentType,
	};

	const userID = Cookies.get(getUserIDKey());
	const uniqueUserID = Cookies.get(getUserUniqueIDKey());

	if ( userID !== undefined && uniqueUserID !== undefined ) {
		headers[getUserIDKey()] = userID;
		headers[getUserUniqueIDKey()] = uniqueUserID;
	}

	// console.log('headers',headers);
	return headers;
};

const getPostHeaders = () => {
	return getHeaders('json');
};

const getPostFormHeaders = () => {
	return getHeaders('form');
};

const parseResponse = async (response) => {
	const responseText = await response.text();

	let responseData = null;
	if (responseText !== '') {
		try {
			responseData = JSON.parse(responseText);
		}
		catch (error) {
			responseData = responseText;
		}
	}

	if (response.ok) {
		if (responseData === null) {
			return {};
		}

		return responseData;
	}

	let errorMessage = response.statusText || 'Request failed.';

	if (responseData && typeof responseData === 'object') {
		errorMessage = responseData.error || responseData.message || errorMessage;
	}
	else if (typeof responseData === 'string' && responseData.trim() !== '') {
		errorMessage = responseData;
	}

	throw new Error(errorMessage);
};

const sendRequest = async (url, jsonBody) => {
	return fetch(`${webHost()}${url}`, {
		method: 'POST',
		headers: getPostHeaders(),
		body: JSON.stringify(jsonBody),
		mode: 'cors',
	})
	.then(parseResponse)
	.catch(error => {
		console.log('----------req error: ' + url);
		console.log(error && error.message ? error.message : error);
		throw error;
	});
};

const sendFormRequest = async (url, formData) => {
	return fetch(`${webHost()}${url}`, {
		method: 'POST',
		headers: getPostFormHeaders(),
		body: formData,
		mode: 'cors',
	})
	.then(parseResponse)
	.catch(error => {
		console.log('----------req error: ' + url);
		console.log(error && error.message ? error.message : error);
		throw error;
	});
};

const uploadFileToSignedUrl = (signedUrl, file, options = {}) => {
	const {
		contentType,
		onProgress,
	} = options;

	return new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();

		xhr.open('PUT', signedUrl);

		if (typeof contentType === 'string' && contentType.trim() !== '') {
			xhr.setRequestHeader('Content-Type', contentType);
		}

		xhr.upload.onprogress = (event) => {
			if (!event.lengthComputable || typeof onProgress !== 'function') {
				return;
			}

			const uploadProgress = Math.min(100, Math.round((event.loaded / event.total) * 100));
			onProgress(uploadProgress);
		};

		xhr.onload = () => {
			if (xhr.status >= 200 && xhr.status < 300) {
				if (typeof onProgress === 'function') {
					onProgress(100);
				}
				resolve();
				return;
			}

			reject(new Error(`Upload failed (${xhr.status}).`));
		};

		xhr.onerror = () => {
			reject(new Error('Upload failed. Please try again.'));
		};

		xhr.send(file);
	});
};

const setAuthDetails = (userID, userUniqueID) => {
	Cookies.set(getUserIDKey(), userID.toString() );
	Cookies.set(getUserUniqueIDKey(), userUniqueID.toString() );
};

const removeAuthDetails = () => {
	Cookies.remove(getUserIDKey());
	Cookies.remove(getUserUniqueIDKey());
	Cookies.remove('email');
	Cookies.remove('firstName');
	Cookies.remove('lastName');
};

const setUserInfo = (userInfo) => {
	// Cookies.set('email', userInfo.email);
	Cookies.set('firstName', userInfo.firstName);
	Cookies.set('lastName', userInfo.lastName);
	Cookies.set('nickname', userInfo.nickname);
};

const setUserNickname = (nickname) => {
	Cookies.set('nickname', nickname);
};

const getUserEmail = () => {
	return Cookies.get('email');
};

const getUserFirstName = () => {
	return Cookies.get('firstName');
};

const getUserLastName = () => {
	return Cookies.get('lastName');
};

const getUserNickname = () => {
	return Cookies.get('nickname');
};

export {
	isDev,
	websocketHost,

	sendRequest,
	sendFormRequest,
	uploadFileToSignedUrl,

	setUserNickname,

	getCurrentUserID,
	getUserFirstName,
	getUserLastName,
	getUserNickname,

	isLoggedIn,
	setAuthDetails,
	setUserInfo,
	getUserEmail,
	removeAuthDetails,
};